export default __webpack_public_path__ + "static/media/kb.b91cfc68.png";